/**
 * 文章资讯列表页面路径
 */
export const NEWS_LIST_PAGE_PATH = '/news/list'

/**
 * 文章资讯创建页面路径
 */
export const NEWS_CREATE_PAGE_PATH = '/news/create'

/**
 * 文章资讯编辑页面路径
 */
export const NEWS_EDIT_PAGE_PATH = '/news/edit'
